module.exports = __webpack_public_path__ + "static/img/is.cc33fe26.svg";